/**
 * Efeito de celebração — porta de `showParticles` [application.js:1321].
 *
 *  - showConfetti(): confete das duas bordas inferiores por ~2s (canvas-confetti,
 *    importado sob demanda para ficar fora do bundle principal). Só nos marcos raros
 *    (decisão M7 b, 23/10/2026, que amplia a D15): compra liberada, adesão ao programa de
 *    recomendação e a primeira lista enriquecida da pessoa (o fim da captura com leads, subir de
 *    nível e a nova versão também, quando existirem no painel). Semelhantes e Enriquecer do dia a
 *    dia mostram só o ✓ de sucesso.
 *
 * Movimento (design system de movimento, 23/10/2026): com "reduzir movimento" (no sistema ou na
 * opção do produto, <html data-movimento="reduzido">) não há confete: o ✓ e o texto ficam. Dois
 * pedidos no mesmo momento dão um confete só. O confete passa por cima das janelas, porque vem
 * junto com o texto do que aconteceu; o canvas não pega clique nem tem conteúdo para o leitor de
 * tela.
 */
import { semMovimento } from './movimento';

// Cores da paleta do guia: --amarelo, --tinta, --tinta-4 e --linha-forte.
const CONFETTI_COLORS = ['#FFB500', '#1D2026', '#9AA0AC', '#D3D6DD'];
/** Cerca de 2 s de confete (N5 do guia). */
const DURATION_MS = 2000;
/** Acima das janelas e véus do painel (até 999999) e da tela de carregamento (1000000). */
const Z_INDEX = 1000001;

let running = false;

export function showConfetti(): void {
  if (running || semMovimento()) return;
  running = true;
  void import('canvas-confetti')
    .then(({ default: confetti }) => {
      const end = Date.now() + DURATION_MS;
      const interval = setInterval(() => {
        if (Date.now() >= end) {
          clearInterval(interval);
          running = false;
          return;
        }
        // Com "reduzir movimento" no sistema, o próprio canvas-confetti também não desenha nada.
        confetti({
          particleCount: 2,
          angle: 60,
          spread: 55,
          origin: { x: 0, y: 0.9 },
          colors: CONFETTI_COLORS,
          zIndex: Z_INDEX,
          disableForReducedMotion: true,
        });
        confetti({
          particleCount: 2,
          angle: 120,
          spread: 55,
          origin: { x: 1, y: 0.9 },
          colors: CONFETTI_COLORS,
          zIndex: Z_INDEX,
          disableForReducedMotion: true,
        });
      }, 10);
    })
    .catch(() => {
      running = false;
      /* confete é decorativo — falha silenciosa */
    });
}
